import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { ConfigService } from './core/config.service';
import { StoreModule } from './store/store.module';
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { AuthService } from './core/auth/auth.service';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingService } from './shared/service/loading.service';

export const configFactory = (configService: ConfigService) => {
  return () => configService.loadConfig()
}

@NgModule({ 
  declarations: [
        AppComponent
    ],
  bootstrap: [AppComponent],
  imports: [
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    StoreModule,
    // TranslateModule.forRoot({
    //     loader: provideTranslateHttpLoader({
    //       prefix:"./assets/i18n/",
    //       suffix:".json",
    //       useHttpBackend: true
    //     }),
    //     fallbackLang: 'en'
    // })
  ], 
  providers: [
    AuthService,
    provideTranslateService(
      {
        fallbackLang: 'en',
        loader: provideTranslateHttpLoader({
          prefix:"./assets/i18n/",
          suffix:".json",
          useHttpBackend: true
        }),
      }
    ),
    provideAppInitializer(() => {
          const initializerFn = (configFactory)(inject(ConfigService));
          return initializerFn();
        }),
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        deps: [AuthService, LoadingService],
        multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }
